import { Box, Paper } from "@mui/material";

export default function Card1({ title, style = {}, children }) {
  return (
    <Box className="my-card" sx={{ padding: "2%", width: "100%", ...style }}>
      <h5 style={{ color: "rgb(124, 124, 124)" }}>{title}</h5>
      {children}
    </Box>
  );
}
